import React from 'react';

const LoadingIndicator = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white z-50" data-testid="loading-spinner">
            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
        </div>
    );
};

export default LoadingIndicator;